export const S = {
  bg:'#080c10', card:'#0f1520', card2:'#131c2a',
  border:'#1e2d40', gold:'#ffd600', danger:'#ef5350',
  success:'#66bb6a', txt:'#e8f4fd', muted:'#5a7a99'
};
